// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"7bf89179","261":"48391fd8","386":"a00125df","424":"3e7e685e","453":"8ab44547","602":"233cefb3","913":"10b7eb73"}[chunkId] + ".chunk.js";
};